// Environment configuration utility
// Priority: window.__ENV__ (ConfigMap runtime) > import.meta.env (build-time) > fallback

declare global {
  interface Window {
    __ENV__?: {
      VITE_KEYCLOAK_URL?: string;
      VITE_KEYCLOAK_REALM?: string;
      VITE_KEYCLOAK_CLIENT_ID?: string;
      VITE_API_BASE_URL?: string;
      VITE_SEAHORSE_CONSOLE_URL?: string;
    };
  }
}

const getEnv = (key: string, fallback: string): string => {
  // 1. ConfigMap (runtime) - injected via docker-entrypoint.sh
  const runtimeValue = window.__ENV__?.[key as keyof typeof window.__ENV__];
  if (runtimeValue) {
    return runtimeValue;
  }

  // 2. Build-time env (.env file)
  const buildTimeValue = import.meta.env[key];
  if (buildTimeValue) {
    return buildTimeValue;
  }

  // 3. Fallback
  return fallback;
};

export const env = {
  VITE_KEYCLOAK_URL: getEnv('VITE_KEYCLOAK_URL', 'https://auth.seahorse.dnotitia.com'),
  VITE_KEYCLOAK_REALM: getEnv('VITE_KEYCLOAK_REALM', 'seahorse'),
  VITE_KEYCLOAK_CLIENT_ID: getEnv('VITE_KEYCLOAK_CLIENT_ID', 'seahorse-account-console'),
  VITE_API_BASE_URL: getEnv('VITE_API_BASE_URL', 'https://auth.seahorse.dnotitia.com/realms/seahorse/account'),
  VITE_SEAHORSE_CONSOLE_URL: getEnv('VITE_SEAHORSE_CONSOLE_URL', 'https://console.seahorse.dnotitia.com'),
};

export default env;
